/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlProductType = {
    Cyber: 'CYBER',
    Mdr: 'MDR',
    All: 'ALL'
} as const;
export type ControlProductType = typeof ControlProductType[keyof typeof ControlProductType];


export function ControlProductTypeFromJSON(json: any): ControlProductType {
    return ControlProductTypeFromJSONTyped(json, false);
}

export function ControlProductTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlProductType {
    return json as ControlProductType;
}

export function ControlProductTypeToJSON(value?: ControlProductType | null): any {
    return value as any;
}

